export const COMPANY_AUTH = {
  companyNameInput: 'company-register-name-input',
  adminNameInput: 'company-register-admin-name-input',
  adminEmailInput: 'company-register-admin-email-input',
  adminPasswordInput: 'company-register-admin-password-input',
  acceptTermsCheckbox: 'company-register-accept-terms-checkbox',
  submitButton: 'company-register-submit-button',
  loginLink: 'company-register-login-link',
  devVerificationBanner: 'dev-verification-link-banner',
  verifyStatus: 'verify-email-status',
  resendButton: 'resend-verification-button',
};

export const ONBOARDING = {
  industrySelect: 'onboarding-industry-select',
  sizeSelect: 'onboarding-size-select',
  moduleCheckbox: 'onboarding-module-checkbox',
  submitButton: 'onboarding-submit-button',
};
